import { GET_VENDOR_DETAILS, GET_VENDOR_DETAILS_SUCCESS, GET_VENDOR_DETAILS_ERROR, GET_VENDOR_DETAILS_EMPTY } from '../../actions.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorDetails = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_DETAILS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DETAILS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DETAILS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDOR_DETAILS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorDetails;
